import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Michelle Serrano',
    role: 'CEO, Intangibles Talent',
    avatar: 'https://cdn.magicpatterns.com/uploads/b4GPShxYkJ6AnzdUBaLEav/WhatsApp_Image_2026-06-05_at_10.19.08.jpg',
    quote: 'TALVORI completely transformed how we hire. The quality of candidates they presented within just a week was outstanding. They truly understand what makes a great fit beyond just the resume.'
  }, {
    name: 'Mariana Gongora',
    role: 'Executive Officer, Grupo BPN',
    avatar: 'https://cdn.magicpatterns.com/uploads/ee4BcEDw1RgvDfEehNE2fm/WhatsApp_Image_2026-06-08_at_11.51.59.jpg',
    quote: "Working with TALVORI feels like having an internal recruiting team. They are incredibly responsive, deeply strategic, and the talent we've hired through them has been exceptional."
  }, {
    name: 'Alejandro Ortega',
    role: 'CEO, TMG International',
    avatar: 'https://cdn.magicpatterns.com/uploads/t6ki1uyUEypY16FR7HGDxM/494769363_122114962214833228_1416114980014905561_n.jpg',
    quote: 'The speed and precision of their process is unmatched. We needed specialized roles filled quickly, and TALVORI delivered top-tier professionals who integrated seamlessly into our operations.'
  }, {
    name: 'Samantha Brooks',
    role: 'CEO, Bold Enterprise',
    avatar: 'https://cdn.magicpatterns.com/uploads/581RXayZbu1doordUZHKHb/IMG_6059.png',
    quote: "I wanted to hire in LATAM but didn't want to go through an expensive staffing firm. Orianna answered all my questions and walked me through the process, and then I decided to go ahead with recruiting. She did a great job with the search, vetted a lot of candidates, and brought me only the highest-quality candidates to interview. I was extremely impressed with all of them and have been very happy with their work. Highly recommend TALVORI."
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section id="testimonials" className="py-24 bg-navy overflow-hidden" data-id="element-265">
      <div className="max-w-7xl mx-auto px-6" data-id="element-266">
        <div className="text-center mb-16" data-id="element-267">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-12 text-white" data-id="element-268">
            Trusted by Growing Companies
          </motion.h2>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-269">
          <div className="absolute top-1/2 -translate-y-1/2 -left-4 md:-left-12 z-10" data-id="element-270">
            <button onClick={prev} className="w-10 h-10 rounded-full bg-white shadow-soft border border-slate-100 flex items-center justify-center text-slate-600 hover:text-navy hover:scale-110 transition-all" data-id="element-271">
              <ChevronLeft className="w-5 h-5" data-id="element-272" />
            </button>
          </div>

          <div className="absolute top-1/2 -translate-y-1/2 -right-4 md:-right-12 z-10" data-id="element-273">
            <button onClick={next} className="w-10 h-10 rounded-full bg-white shadow-soft border border-slate-100 flex items-center justify-center text-slate-600 hover:text-navy hover:scale-110 transition-all" data-id="element-274">
              <ChevronRight className="w-5 h-5" data-id="element-275" />
            </button>
          </div>

          <div className="bg-slate-50 rounded-4xl p-8 md:p-16 relative" data-id="element-276">
            <Quote className="absolute top-8 left-8 w-12 h-12 text-slate-200" data-id="element-277" />

            <AnimatePresence mode="wait" data-id="element-278">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="relative z-10 text-center" data-id="element-279">
                <div className="flex justify-center gap-1 mb-8" data-id="element-280">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-coral text-coral" data-id="element-281" />)}
                </div>

                <p className="text-xl md:text-2xl text-navy font-medium leading-relaxed mb-8" style={{
                fontFamily: '"Poppins", sans-serif'
              }} data-id="element-282">
                  "{testimonials[currentIndex].quote}"
                </p>

                <div className="flex flex-col items-center" data-id="element-283">
                  {testimonials[currentIndex].avatar ? <img src={testimonials[currentIndex].avatar} alt={testimonials[currentIndex].name} className="w-32 h-32 rounded-full object-cover mb-4 ring-2 ring-white shadow-soft" data-id="element-284" /> : <div className="w-32 h-32 rounded-full bg-brand-gradient flex items-center justify-center text-white font-bold text-2xl mb-4 shadow-soft" data-id="element-285">
                      {testimonials[currentIndex].name.split(' ').map(n => n[0]).join('')}
                    </div>}
                  <div className="font-bold text-navy text-lg" data-id="element-286">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="text-slate-500" data-id="element-287">
                    {testimonials[currentIndex].role}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center gap-2 mt-8" data-id="element-288">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? 'bg-navy w-8' : 'bg-slate-300 hover:bg-slate-400'}`} data-id="element-289" />)}
          </div>
        </div>
      </div>
    </section>;
}